
import { atom } from 'recoil'

export const isOpenDeleteConfirmationState = atom({
  key: 'isOpenDeleteConfirmationState',
  default: false
})
